import { Text, Icon, tailwindPreset } from '@southfields-digital/mpxlive-components';
import classNames from 'classnames';

import styles from './DataConnectorPanel.module.scss';

type ErrorDisplayProps = {
  error: string;
};

export const ErrorDisplay = ({ error }: ErrorDisplayProps) => {
  return (
    <div className={classNames(styles.ErrorBox, styles.Error)}>
      <div>
        <Icon icon="x-circle" color={tailwindPreset.theme.extend.colors.danger} />
      </div>
      <div>
        <Text as="p" className={styles.ErrorTitle}>
          Error
        </Text>
        <Text as="p" className={styles.ErrorMessage}>
          {error}
        </Text>
      </div>
    </div>
  );
};
